import { gql } from '@apollo/client';

// 파일 정보 입력 타입 정의 (스키마에서 필요)
gql`
  input FileInfoInput {
    name: String!
    url: String!
    size: Int
    type: String
  }
`;

// 내 견적 요청 목록 조회
export const GET_MY_QUOTATIONS = gql`
  query GetMyQuotations {
    myQuotations {
      id
      status
      message
      adminReply
      attachmentUrl
      customerFiles {
        name
        url
        size
        type
      }
      totalAmount
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      quotationItems {
        id
        quantity
        requestedPrice
        finalPrice
        createdAt
        product {
          id
          name
          description
          specifications
          price
          discountPrice
          stock
          images
          isActive
          mainCategory {
            id
            name
          }
          subCategory {
            id
            name
          }
        }
      }
    }
  }
`;

// 모든 견적 요청 조회 (관리자용)
export const GET_QUOTATIONS = gql`
  query GetQuotations {
    quotations {
      id
      status
      message
      adminReply
      attachmentUrl
      customerFiles {
        name
        url
        size
        type
      }
      totalAmount
      createdAt
      updatedAt
      user {
        id
        name
        email
        company
      }
      quotationItems {
        id
        quantity
        requestedPrice
        finalPrice
        createdAt
        product {
          id
          name
          description
          specifications
          price
          discountPrice
          stock
          images
          isActive
          mainCategory {
            id
            name
          }
          subCategory {
            id
            name
          }
        }
      }
    }
  }
`;

// 특정 견적 요청 조회
export const GET_QUOTATION = gql`
  query GetQuotation($id: Int!) {
    quotation(id: $id) {
      id
      status
      message
      adminReply
      attachmentUrl
      customerFiles {
        name
        url
        size
        type
      }
      totalAmount
      createdAt
      updatedAt
      user {
        id
        name
        email
        company
        phone
        mobile
        zipCode
        address
        addressDetail
        ceoName
        businessNumber
        department
        fax
        level
        deliveryAddresses {
          id
          name
          recipient
          phone
          zipCode
          address
          addressDetail
          isDefault
        }
      }
      quotationItems {
        id
        quantity
        requestedPrice
        finalPrice
        createdAt
        product {
          id
          name
          description
          specifications
          price
          discountPrice
          stock
          images
          isActive
          mainCategory {
            id
            name
          }
          subCategory {
            id
            name
          }
        }
      }
    }
  }
`;

// 견적 요청 생성
export const CREATE_QUOTATION = gql`
  mutation CreateQuotation($message: String, $items: [CartItemInput!], $customerFiles: [FileInfoInput!]) {
    createQuotation(message: $message, items: $items, customerFiles: $customerFiles) {
      id
      status
      message
      adminReply
      attachmentUrl
      totalAmount
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      quotationItems {
        id
        quantity
        requestedPrice
        finalPrice
        createdAt
        product {
          id
          name
          description
          specifications
          price
          discountPrice
          stock
          images
          isActive
          mainCategory {
            id
            name
          }
          subCategory {
            id
            name
          }
        }
      }
    }
  }
`;

// 견적 상태 업데이트 (관리자용)
export const UPDATE_QUOTATION_STATUS = gql`
  mutation UpdateQuotationStatus($id: Int!, $status: QuotationStatus!, $adminReply: String, $attachmentUrl: String) {
    updateQuotationStatus(id: $id, status: $status, adminReply: $adminReply, attachmentUrl: $attachmentUrl) {
      id
      status
      message
      adminReply
      attachmentUrl
      totalAmount
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      quotationItems {
        id
        quantity
        requestedPrice
        finalPrice
        createdAt
        product {
          id
          name
          description
          specifications
          price
          discountPrice
          stock
          images
          isActive
          mainCategory {
            id
            name
          }
          subCategory {
            id
            name
          }
        }
      }
    }
  }
`;

// 월별 견적 통계 조회
export const GET_MONTHLY_QUOTATION_STATS = gql`
  query GetMonthlyQuotationStats($year: Int!) {
    monthlyQuotationStats(year: $year) {
      month
      totalQuotations
      percentage
      aGradeCount
      bGradeCount
      cGradeCount
      dGradeCount
    }
  }
`;

// 현재 견적 수 조회
export const GET_CURRENT_QUOTATION_COUNT = gql`
  query GetCurrentQuotationCount {
    currentQuotationCount
  }
`;

// 대시보드 견적 통계 조회
export const GET_DASHBOARD_QUOTATION_STATS = gql`
  query GetDashboardQuotationStats {
    dashboardQuotationStats {
      newQuotations
      totalQuotations
      pendingQuotations
      completedQuotations
      emailSentQuotations
    }
  }
`;

// 최근 견적 목록 조회 (대시보드용)
export const GET_RECENT_QUOTATIONS = gql`
  query GetRecentQuotations($limit: Int) {
    recentQuotations(limit: $limit) {
      id
      status
      message
      createdAt
      user {
        id
        name
        email
        company
      }
    }
  }
`;

 